"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PullWireSchema = void 0;
const zod_1 = require("zod");
const InputJsonValue_1 = require("../inputTypeSchemas/InputJsonValue");
const DataSourceSchema_1 = require("../inputTypeSchemas/DataSourceSchema");
const ChainflexCategorySchema_1 = require("../inputTypeSchemas/ChainflexCategorySchema");
const ArticleSpecSchema_1 = require("../inputTypeSchemas/ArticleSpecSchema");
const ArticleTypeSchema_1 = require("../inputTypeSchemas/ArticleTypeSchema");
const LengthUnitSchema_1 = require("../inputTypeSchemas/LengthUnitSchema");
const WeightPerLengthUnitSchema_1 = require("../inputTypeSchemas/WeightPerLengthUnitSchema");
/////////////////////////////////////////
// PULL WIRE SCHEMA
/////////////////////////////////////////
exports.PullWireSchema = zod_1.z.object({
    dataSource: DataSourceSchema_1.DataSourceSchema,
    categories: ChainflexCategorySchema_1.ChainflexCategorySchema.array(),
    articleSpecs: ArticleSpecSchema_1.ArticleSpecSchema.array(),
    articleType: ArticleTypeSchema_1.ArticleTypeSchema,
    chainBendRadiusMinUnit: LengthUnitSchema_1.LengthUnitSchema,
    mainCategory: ChainflexCategorySchema_1.ChainflexCategorySchema,
    outerDiameterUnit: LengthUnitSchema_1.LengthUnitSchema,
    weightUnit: WeightPerLengthUnitSchema_1.WeightPerLengthUnitSchema,
    akeneoSku: zod_1.z.string(),
    akeneoUuid: zod_1.z.string().nullish(),
    discontinuedModel: zod_1.z.boolean(),
    echainId: zod_1.z.string(),
    ecfAllowed: zod_1.z.boolean(),
    eicAllowed: zod_1.z.boolean(),
    eiqAllowed: zod_1.z.boolean(),
    ekeAllowed: zod_1.z.boolean(),
    artNr: InputJsonValue_1.InputJsonValue,
    chainBendRadiusMin: zod_1.z.number(),
    crossSection: InputJsonValue_1.InputJsonValue,
    description: InputJsonValue_1.InputJsonValue,
    numberOfCores: zod_1.z.string(),
    outerDiameter: zod_1.z.number(),
    outerJacket: zod_1.z.string(),
    ralnumber: zod_1.z.string(),
    weight: zod_1.z.number(),
});
exports.default = exports.PullWireSchema;
//# sourceMappingURL=PullWireSchema.js.map